module.exports = __webpack_public_path__ + "img/shek.e52f6c2e.jpg";